import Vue from 'vue'
import auth0 from 'auth0-js'

const domain = window.location.hostname.split('.').reverse().splice(0, 2).reverse().join('.')

const removeToken = () => {
    document.cookie = `op_forecasting_cookie_auth0=;path=/;domain=${domain};expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

const auth = {
    install: (VueInstance) => {
        const self = Vue

        /* eslint-disable-next-line */
        const token = document.cookie.replace(/(?:(?:^|.*;\s*)op_forecasting_cookie_auth0\s*\=\s*([^;]*).*$)|^.*$/, '$1')
        self.auth = {
            authenticated: false,
            token
        }

        self.auth.setToken = (token) => {
            document.cookie = `op_forecasting_cookie_auth0=${token};path=/;domain=${domain};expires=Fri, 31 Dec 9999 23:59:59 GMT`
            self.token = token
        }

        self.auth.webAuth = new auth0.WebAuth({
            domain: 'ragnorak.auth0.com',
            clientID: 'UM37h1028DNxfKYVpAIMjZ6DjfSuWgAT',
            responseType: 'token'
        })

        self.auth.login = (token, email) => {
            self.auth.token = token
            document.cookie = `op_forecasting_cookie_auth0=${token};path=/;domain=${domain};expires=Fri, 31 Dec 9999 23:59:59 GMT`
            self.auth.authenticated = true
            self.auth.profile = {email}
        }

        self.auth.logout = () => {
            removeToken()
            self.auth.authenticated = false
        }
        self.auth.authenticate = () => self.auth.webAuth.client.userInfo(self.auth.token, (error, profile) => {
            if (error) {
                removeToken()
            } else if (profile) {
                self.auth.profile = profile
                self.auth.authenticated = true
            }
        })

        // Hacky, but auth sub-properties are reactive
        const reactiveAuth = new Vue({data: {auth: self.auth}})
        VueInstance.prototype.$auth = reactiveAuth.auth
        VueInstance.$auth = reactiveAuth.auth
    }
}

export default auth
